const LocalStorage = window.localStorage

export default LocalStorage
